require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-institution-world-bank-group.json") })
        }
      }, "path---en-us-institution-world-bank-group");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-institution-world-bank-group!./.cache/json/en-us-institution-world-bank-group.json
// module id = 482
// module chunks = 231608221292675